// @ftedn/shared — Firestore collection names
// Single source of truth — NEVER use string literals in app code

export const COLLECTIONS = {
  USERS: 'users',
  CREATORS: 'creators',
  TEAM_MEMBERS: 'teamMembers',
  TEAM_USERS: 'teamUsers',
  CONTENT: 'content',
  CAMPAIGNS: 'campaigns',
  MESSAGES: 'messages',
  MESSAGE_THREADS: 'messageThreads',
  NOTIFICATIONS: 'notifications',
  PUSH_SUBSCRIPTIONS: 'pushSubscriptions',
  PAYMENTS: 'payments',
  SHIPMENTS: 'shipments',
  AFFILIATES: 'affiliates',
  APP_CONFIG: 'appConfig',
  AUDIT_LOG: 'auditLog',
  // FTEDN-specific collections
  BETA_PROGRAMS: 'betaPrograms',
  BETA_APPLICATIONS: 'betaApplications',
  PRODUCT_FEEDBACK: 'productFeedback',
  PRODUCT_REVIEWS: 'productReviews',
  SHIPMENT_TRACKING: 'shipmentTracking',
  VOTING_CARDS: 'votingCards',
  VOTES: 'votes',
  IDEA_SUBMISSIONS: 'ideaSubmissions',
  COMMUNITY_POSTS: 'communityPosts',
  COMMENTS: 'comments',
  CHAT_CHANNELS: 'chatChannels',
  WAITLIST: 'waitlist',
  // Feature flag overrides
  FLAG_OVERRIDES_GLOBAL: 'flagOverrides/global',
  FLAG_OVERRIDES_COHORT: 'flagOverrides/cohort',
  // I3: Product tracking
  PRODUCTS: 'products',
  PRODUCT_CONTRIBUTIONS: 'productContributions',
  PRODUCT_TRANSITION_LOG: 'productTransitionLog',
} as const;

export type CollectionName = typeof COLLECTIONS[keyof typeof COLLECTIONS];
